import { useEffect } from "react";

const usePageTitle = (subtitle) => {
  useEffect(() => {
    document.title = subtitle ? `Scan Loom | ${subtitle}` : "Scan Loom";
    return () => { document.title = "Scan Loom"; };
  }, [subtitle]);
};

export default usePageTitle;
